export default "__VITE_ASSET__CQq3saOt__"